import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a0d4aab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "promoted-section",
  ref: "container"
}
const _hoisted_2 = ["aria-labelledby"]
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Promoted ")
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", {
      tabindex: "-1",
      "aria-labelledby": _ctx.id
    }, [
      _createElementVNode("h2", { id: _ctx.id }, [
        _createVNode(_component_font_awesome_icon, { icon: "external-link-square-alt" }),
        _hoisted_4
      ], 8, _hoisted_3),
      _createElementVNode("a", {
        href: _ctx.url,
        title: _ctx.textDescription,
        target: "_blank",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
      }, [
        _createElementVNode("img", {
          src: _ctx.imgSrc,
          alt: _ctx.textDescription
        }, null, 8, _hoisted_6)
      ], 8, _hoisted_5)
    ], 8, _hoisted_2)
  ], 512))
}